import React from "react";

export default function Pagination({
  page,
  totalPages,
  total,
  limit = 10,
  loading = false,
  onPrevious,
  onNext,
}) {
  const start =
    total > 0
      ? (page - 1) * limit + 1
      : 0;

  const end =
    total > 0
      ? Math.min(page * limit, total)
      : 0;

  return (
    <div className="pagination">

      {/* Showing information */}
      <span className="pagin-info">
        {total > 0
          ? `Showing ${start}–${end} of ${total}`
          : "Showing 0 of 0"}
      </span>

      {/* Pagination buttons */}
      <div className="d-flex align-items-center gap-2">

        {/* Previous */}
        <button
          type="button"
          className="pg-btn"
          disabled={
            loading || page <= 1
          }
          onClick={onPrevious}
        >
          ← Prev
        </button>

        {/* Current page */}
        <span className="pagin-info">
          Page {page} / {totalPages || 1}
        </span>

        {/* Next */}
        <button
          type="button"
          className="pg-btn"
          disabled={
            loading ||
            page >= totalPages ||
            totalPages <= 0
          }
          onClick={onNext}
        >
          Next →
        </button>

      </div>
    </div>
  );
}

